import {AfterViewChecked, Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {CommonService} from "../../../../shared/services/common.service";
import {debounceTime, Subject, takeUntil} from "rxjs";
import {DomSanitizer} from "@angular/platform-browser";
import {v4 as uuidv4} from 'uuid';
import {addResources} from "../../../../shared/constants/validation.constants";
import {ResourcesHubService} from "../../core/resources-hub.service";

@Component({
  selector: 'app-add-google-slides',
  templateUrl: './add-google-slides.component.html',
  styleUrls: ['./add-google-slides.component.css']
})
export class AddGoogleSlidesComponent implements OnInit, OnDestroy, AfterViewChecked {
  layoutData: any;
  data: any
  @Output() layoutDataChangedEmitter: EventEmitter<any> = new EventEmitter()
  googleSlidesForm: FormGroup = new FormGroup<any>({
    googleSlideUrl: new FormControl('', [Validators.required, Validators.pattern(addResources.googleSlides.regex)])
  });
  errorMessages: any = {};
  errorMessageMap = {
    googleSlideUrl: {
      required: 'This field is required',
      pattern: 'Only google slides embedded link is allowed',
    },
  }
  showPreview: boolean = false;
  UUID = uuidv4();
  previousValue: string = '';
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(private commonService: CommonService, private domSanitizer: DomSanitizer, private resourceHubService: ResourcesHubService) {
  }


  ngOnInit(): void {
    this.layoutData = this.data.layoutData;
    this.googleSlidesForm.patchValue({googleSlideUrl: this.layoutData.googleSlideUrl}, {emitEvent: false})

    if (new RegExp(addResources.googleSlides.regex).test(this.layoutData.googleSlideUrl)) {
      this.showPreview = true;
    } else {
      if (this.layoutData?.googleSlideUrl) {
        this.checkForErrors();
      }
      this.showPreview = false;
    }

    this.googleSlidesForm.valueChanges
      .pipe(takeUntil(this.onDestroy), debounceTime(1000))
      .subscribe(values => {
        this.previousValue = values.googleSlideUrl;
        const updatedLayoutData = {
          ...this.layoutData,
          ...values
        }
        this.resourceHubService.sendDataToParent({
          sectionUuid: this.data.sectionUuid,
          contentUuid: this.data.contentUuid,
          layoutData: updatedLayoutData,
          currentComponentIndex: this.data.currentComponentIndex,
        })
        this.resourceHubService.setLastUpdatedId(null)

        if (this.googleSlidesForm.invalid) {
          this.checkForErrors();
          this.showPreview = false;
          return
        }
      })
  }

  ngAfterViewChecked(): void {
    const slideWrapper = $('.slide-wrapper-' + this.UUID);
    if (slideWrapper && slideWrapper?.get(0)?.getBoundingClientRect()?.width) {
      const slideWidth = slideWrapper?.get(0)?.getBoundingClientRect()?.width
      const iframe = $(`.slide-wrapper-${this.UUID} iframe`);
      iframe.get(0)?.setAttribute('width', slideWidth.toString());
      iframe.get(0)?.removeAttribute('height');
      iframe.css('aspect-ratio', '4/3');
    }
  }

  getSanitizedContent(content) {
    return this.domSanitizer.bypassSecurityTrustHtml(content);
  }

  checkPatternValidator() {
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.googleSlidesForm, this.errorMessageMap, currentField))
    };
  }

  deleteGoogleSlidesLink() {
    this.showPreview = false;
    this.googleSlidesForm.setValue({
      googleSlideUrl: ""
    })
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }


}
